/* Toast Plugin
 * Ref: https://github.com/caroso1222/notyf
 *
 * How to use
 * // Create an instance of Notyf
    var notyf = new Notyf();

    // Display an error notification
    notyf.error('You must fill out the form before moving forward');

    // Display a success notification
    notyf.success('Your changes have been successfully saved!');
 */
import { Notyf } from 'notyf/notyf.js';

(function (window) {
  const notyf = new Notyf({
    position: { x: 'left', y: 'bottom' },
  });
  window.Notyf = Notyf;
  window.notyf = notyf;
})(window);
